export const versionUpdateDialogTextKey = 'VersionUpdateDialog';

export type VersionUpdateDialogText = {
    Title: string;
    Message: string;
    UpdateNow: string;
    UpdateFailedMessage: string;
    ReloadPage: string;
};
